import React, { useEffect, useState } from "react";
import { BlipChat } from "blip-chat-widget";
import { configureEnvironment } from "../../config/env/index";
import { portugues } from "../../shared/utils/AuviousWidgetTraducao";

const ChatWidget = ({ existeScore, exibirVideoChamada }) => {
  const { REACT_PC_DEPLOYMENT_ID, REACT_BLIP_APPKEY, REACT_BLIP_CUSTOM_URL } =
    configureEnvironment();
  const [isWidgetLoaded, setIsWidgetLoaded] = useState(false);

  useEffect(() => {
    if (!existeScore) return;

    const loadWidgetScript = () => {
      if (isWidgetLoaded) return;

      const moduleScript = document.createElement("script");
      moduleScript.type = "module";
      moduleScript.src =
        "https://auvious.video/widget/dist/auvious/auvious.esm.js";
      document.head.appendChild(moduleScript);

      const noModuleScript = document.createElement("script");
      noModuleScript.noModule = true;
      noModuleScript.src =
        "https://auvious.video/widget/dist/auvious/auvious.js";
      document.head.appendChild(noModuleScript);

      setIsWidgetLoaded(true);
    };

    const initializeBlipChat = () => {
      new BlipChat()
        .withAppKey(REACT_BLIP_APPKEY)
        .withButton({ color: "#333172", icon: "" })
        .withCustomCommonUrl(REACT_BLIP_CUSTOM_URL)
        .build();
    };

    const initializeAuviousWidget = async () => {
      await customElements.whenDefined("app-auvious-widget");
      const widget = document.querySelector("app-auvious-widget");
      if (widget) {
        widget.setTranslationFile(portugues);
        document.documentElement.style.setProperty(
          "--av-floating-margin-bottom",
          "5rem"
        );
        document.documentElement.style.setProperty(
          "--av-floating-margin-right",
          "0.5rem"
        );
        document.documentElement.style.setProperty("--av-container-round-width", "45px");
      }
    };

    if (exibirVideoChamada) {
      loadWidgetScript();
      initializeAuviousWidget();
    } else {
      if (!window.BlipChatInitialized) {
        initializeBlipChat();
        window.BlipChatInitialized = true;
      }
    }
  }, [exibirVideoChamada, existeScore, isWidgetLoaded]);

  useEffect(() => {
    return () => {
      if (window.BlipChat) {
        window.BlipChat.destroy();
      }
    };
  }, []);

  return (
    <div>
      {exibirVideoChamada ? (
        <app-auvious-widget
          pc-environment="sae1.pure.cloud"
          application-id="1a544d73-5868-43ae-8be2-aea855c1d1c4"
          pc-organization-id="540838df-4166-4d29-b25c-c67f47f5a2db"
          pc-deployment-id={REACT_PC_DEPLOYMENT_ID}
          locale="pt-BR"
          customer-display-name-broadcast
          active-widgets="video"
          auvious-environment="auvious.video"
          chat-mode="genesys-web-messaging"
        ></app-auvious-widget>
      ) : null}
    </div>
  );
};

export default ChatWidget;
